export default function logout(callback) {
  window.localStorage.clear();

  if (typeof callback == "function") {
    callback();
  }

  // window.localStorage.removeItem("X-Admin-Token");
  // window.localStorage.removeItem("X-Auth-AdminID");
}
